import { type ItemOf } from '@shared/board'
import { clsx } from 'clsx'
import { DRAG_HANDLE, NO_DRAG } from '../classes'
import { ExternalLink, FileText, File as FileIcon } from 'lucide-react'
import { useI18n } from '@/i18n/i18n'
import { useBoardCtx } from '../context'
import { fileUrl, formatBytes } from '../upload'

export function FileView({ item, selected }: { item: ItemOf<'file'>; selected: boolean }) {
  const { boardId } = useBoardCtx()
  const { t } = useI18n()
  const { name, mime, size } = item.data
  const isDoc = mime === 'application/pdf' || mime.startsWith('text/')
  const Icon = isDoc ? FileText : FileIcon
  const ext = name.includes('.') ? name.split('.').pop()?.toUpperCase() : undefined
  return (
    <div
      className={clsx(
        'moot-node ' +
          DRAG_HANDLE +
          ' relative flex cursor-grab items-center gap-3 rounded-md border bg-surface px-3 py-2.5 shadow-sm active:cursor-grabbing',
        selected ? 'border-(--focus)' : 'border-line',
      )}
      style={{ width: item.w }}
    >
      <span className="grid size-9 flex-none place-items-center rounded-sm bg-surface-2 text-muted">
        <Icon size={18} strokeWidth={1.75} />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block truncate text-[13px] font-medium">{name}</span>
        <span className="block text-[11.5px] text-muted">
          {[ext, formatBytes(size)].filter(Boolean).join(' · ')}
        </span>
      </span>
      <a
        href={fileUrl(boardId, item.data.fileKey)}
        target="_blank"
        rel="noreferrer"
        aria-label={t('file.open')}
        title={t('file.open')}
        className={
          NO_DRAG +
          ' grid size-7 flex-none place-items-center rounded-sm text-muted hover:bg-surface-2 hover:text-ink'
        }
      >
        <ExternalLink size={14} />
      </a>
    </div>
  )
}
